"use strict";

require("core-js/modules/es.object.assign.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireDefault(require("react"));
var _xDataGridPro = require("@mui/x-data-grid-pro");
var _material = require("@mui/material");
var _paulCorePackage = require("paul-core-package");
const _excluded = ["columns", "rows", "checkboxSelection", "margin", "autoHeight"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * @class DataGridProTable
 * @param {Array} props.columns
 * @param {Array} props.rows
 * @param {Object} props.tableKeysSessionStorage
 * @param {boolean} props.isClearFilters
 * @param {boolean} props.checkboxSelection
 * @param {string} props.margin
 * @param {boolean} props.autoHeight
 * @param {Object} props.muiProps
 *
 * @return {JSX.Element}
 * @constructor
 */
const DataGridProTable = props => {
  const {
      columns = [],
      rows = [],
      checkboxSelection = false,
      margin = '5px 33.5px 40px 33.5px',
      autoHeight = true
    } = props,
    muiProps = _objectWithoutProperties(props, _excluded);
  return (0, _paulCorePackage.useDeepMemo)(() => /*#__PURE__*/_react.default.createElement(_xDataGridPro.DataGridPro, _extends({}, muiProps, {
    rows: rows,
    columns: columns,
    getRowHeight: () => 'auto',
    autoHeight: autoHeight,
    disableSelectionOnClick: true,
    hideFooter: true,
    throttleRowsMs: 3000,
    components: {
      NoRowsOverlay: () => null,
      NoResultsOverlay: () => /*#__PURE__*/_react.default.createElement(_material.Stack, {
        height: "100%",
        alignItems: "center",
        justifyContent: "center"
      }, "Local filter returns no result")
    },
    sx: {
      color: 'var(--main-color-cl-01)',
      m: margin,
      border: 'none',
      '& .app-header': {
        fontSize: '14px',
        lineHeight: '16px',
        color: 'var(--main-color-cl-01)',
        whiteSpace: 'nowrap',
        outline: 'none'
      },
      '& .app-header:focus': {
        outline: 'none'
      },
      '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: 'bold'
      },
      '& .MuiDataGrid-cell': {
        pt: '12px',
        pb: '6px',
        alignItems: 'start',
        borderBottom: '1px solid var(--main-color-cl-18)'
        // transition: 'var(--transition02)',
      },

      '& .MuiDataGrid-cell:focus': {
        outline: 'none'
      },
      '& .MuiDataGrid-row:hover': {
        backgroundColor: 'var(--main-color-cl-19)'
        // transition: 'var(--transition02)',
      },

      '& .MuiDataGrid-row, &:last-child td': {
        borderBottom: '1px solid var(--main-color-cl-18)'
      },
      '& .breakSpacesCell': {
        whiteSpace: 'break-spaces',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
      },
      '& .nowrapCell': {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
      },
      '& .dateCell': {
        whiteSpace: 'break-spaces !important'
      }
    }
  })), [margin, ...Object.values(muiProps || {}), _columns, autoHeight, sortModel, filterModel, _onSortModelChange, _onFilterModelChange, _onColumnWidthChange, _onColumnVisibilityModelChange, _onColumnOrderChange, columnVisibilityModelTable, rows]);
};
var _default = exports.default = DataGridProTable;